import { render, staticRenderFns } from "./AthletesPage.vue?vue&type=template&id=eceac558&scoped=true&"
import script from "./AthletesPage.vue?vue&type=script&lang=js&"
export * from "./AthletesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eceac558",
  null
  
)

export default component.exports